export default "__VITE_ASSET__BFx43_TA__"